module.exports = __webpack_public_path__ + "static/img/p2_3.42f95b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p2_3.png
// module id = Qb+n
// module chunks = 1